<script>
  import _dropdownitem from '../mixins/_dropdown-item'

  export default {
    name: 'NavbarNavItem',
    mixins: [_dropdownitem]
  }
</script>



// WEBPACK FOOTER //
// navbar-nav-item.vue?483ac936